import SweetAlert from "@components/Feedback/SweetAlert/Index";
import { SaveSolicitacao } from "@services/Solicitacao/Index";
import { atualizarStatus } from "@store/slices/solicitacaoSlice";
import ValidationsCreateSolicitacao from "@validations/Solicitacao/Admin/Create/Validations";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

export const useSubmitSolicitacao = ({
    selectedRow,
    solicitacaoProcessoItems,
    methods,
    setCodigoCompliance,
    setSolicitacaoProcessoItems,
    setSelectedRow,
}) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const onSubmit = async (data) => {
        try {
            const { validateFields } = ValidationsCreateSolicitacao();
            const firstError = await validateFields(data, solicitacaoProcessoItems);

            if (firstError) {
                SweetAlert.error("Erro ao Cadastrar", firstError.message);
                return;
            };

            const title = "Cadastro da Solicitação";
            const htmlMessage = `Deseja realmente salvar a solicitação?`;

            const confirmRegister = await SweetAlert.warningHTML(title, htmlMessage);
            if (!confirmRegister) return;

            SweetAlert.loading();

            const payload = {
                idCompliance: selectedRow.id,
                idTemplateEmailComunicado: data.templateEmailComunicado?.value || null,
                idTemplateEmailSolicitacao: data.templateEmailSolicitacao?.value || null,
                idAuditor: data.nomeAuditor?.value,
                idUnidadeGerencia: data.nomeUnidadeGerencia?.value,
                emailCC: data.emailCC || null,
                observacoes: data.observacoes || null,
                prazoSolicitacao: data.prazoSolicitacao,
                dataLimiteSolicitacao: data.dataLimiteSolicitacao,
                dataAgendarEnvio: data.dataAgendarEnvio || null,
                solicitacaoProcessoItems: solicitacaoProcessoItems,
            };

            console.log("Payload que está sendo enviado:", JSON.stringify(payload, null, 2));

            const result = await SaveSolicitacao(payload);

            if (!result.compliance?.codigo || !result.numeroSolicitacao || !result.unidadeGerencia?.sigla) {
                throw new Error("Informações incompletas para criar a estrutura de pastas.");
            }

            SweetAlert.success('Solicitação Cadastrada!', 'Os dados da solicitação foram salvos com sucesso.');

            dispatch(atualizarStatus({ id: result.id, status: result.numeroStatusSolicitacao }));

            methods.reset();
            setCodigoCompliance('');
            setSolicitacaoProcessoItems([]);
            setSelectedRow(null);

            if (result?.id) {
                navigate(`/Solicitacao/${result.id}`);
            }

        } catch (error) {

            const errorMessage = error.parsed?.message || 'Não foi possível salvar a solicitação.';

            SweetAlert.errorHTML('Erro ao salvar', errorMessage);
        }
    };


    return { onSubmit };
}